var map = {
	"./AlgoliaDocsSearch": 49286,
	"./AlgoliaDocsSearch/": 49286,
	"./AlgoliaDocsSearch/index": 49286,
	"./AlgoliaDocsSearch/index.tsx": 49286,
	"./AppPlayer": 13541,
	"./AppPlayer/": 13541,
	"./AppPlayer/index": 13541,
	"./AppPlayer/index.tsx": 13541,
	"./ArrowLink": 43126,
	"./ArrowLink/": 43126,
	"./ArrowLink/index": 43126,
	"./ArrowLink/index.tsx": 43126,
	"./Badge": 10298,
	"./Badge/": 10298,
	"./Badge/index": 10298,
	"./Badge/index.tsx": 10298,
	"./BlogCTA": 69573,
	"./BlogCTA/": 69573,
	"./BlogCTA/index": 69573,
	"./BlogCTA/index.tsx": 69573,
	"./BlogPlayer": 15360,
	"./BlogPlayer/": 15360,
	"./BlogPlayer/index": 15360,
	"./BlogPlayer/index.tsx": 15360,
	"./BlogPostCard": 84492,
	"./BlogPostCard/": 84492,
	"./BlogPostCard/Featured": 50864,
	"./BlogPostCard/Featured.tsx": 50864,
	"./BlogPostCard/index": 84492,
	"./BlogPostCard/index.tsx": 84492,
	"./BulletedTitle": 19095,
	"./BulletedTitle/": 19095,
	"./BulletedTitle/index": 19095,
	"./BulletedTitle/index.tsx": 19095,
	"./Button": 30676,
	"./Button/": 30676,
	"./Button/index": 30676,
	"./Button/index.tsx": 30676,
	"./Card": 47617,
	"./Card/": 47617,
	"./Card/index": 47617,
	"./Card/index.tsx": 47617,
	"./CaseStudy": 83651,
	"./CaseStudy/": 83651,
	"./CaseStudy/index": 83651,
	"./CaseStudy/index.tsx": 83651,
	"./CenterTitle": 8739,
	"./CenterTitle/": 8739,
	"./CenterTitle/index": 8739,
	"./CenterTitle/index.tsx": 8739,
	"./CentralisedTitle": 48227,
	"./CentralisedTitle/": 48227,
	"./CentralisedTitle/index": 48227,
	"./CentralisedTitle/index.tsx": 48227,
	"./Code": 58186,
	"./Code.tsx": 58186,
	"./Contact": 99245,
	"./Contact/": 99245,
	"./Contact/index": 99245,
	"./Contact/index.tsx": 99245,
	"./CutOut": 61232,
	"./CutOut/": 61232,
	"./CutOut/index": 61232,
	"./CutOut/index.tsx": 61232,
	"./DefaultError": 14039,
	"./DefaultError/": 14039,
	"./DefaultError/index": 14039,
	"./DefaultError/index.tsx": 14039,
	"./Docs/TableOfContents": 25559,
	"./Docs/TableOfContents.tsx": 25559,
	"./EmbedHtml": 84406,
	"./EmbedHtml/": 84406,
	"./EmbedHtml/index": 84406,
	"./EmbedHtml/index.tsx": 84406,
	"./Faq": 80824,
	"./Faq/": 80824,
	"./Faq/index": 80824,
	"./Faq/index.tsx": 80824,
	"./FeaturedAppsSection": 94015,
	"./FeaturedAppsSection/": 94015,
	"./FeaturedAppsSection/index": 94015,
	"./FeaturedAppsSection/index.tsx": 94015,
	"./Figure": 31246,
	"./Figure/": 31246,
	"./Figure/index": 31246,
	"./Figure/index.tsx": 31246,
	"./Footer": 33556,
	"./Footer/": 33556,
	"./Footer/index": 33556,
	"./Footer/index.tsx": 33556,
	"./Form": 92599,
	"./Form/": 92599,
	"./Form/index": 92599,
	"./Form/index.tsx": 92599,
	"./GoogleTagManager": 32697,
	"./GoogleTagManager/": 32697,
	"./GoogleTagManager/index": 32697,
	"./GoogleTagManager/index.tsx": 32697,
	"./GuideSection": 94546,
	"./GuideSection/": 94546,
	"./GuideSection/index": 94546,
	"./GuideSection/index.tsx": 94546,
	"./Guides": 4199,
	"./Guides/": 4199,
	"./Guides/index": 4199,
	"./Guides/index.tsx": 4199,
	"./Hero": 62571,
	"./Hero/": 62571,
	"./Hero/index": 62571,
	"./Hero/index.tsx": 62571,
	"./HeroImage": 38393,
	"./HeroImage/": 38393,
	"./HeroImage/index": 38393,
	"./HeroImage/index.tsx": 38393,
	"./HomeHero": 89700,
	"./HomeHero/": 89700,
	"./HomeHero/PhoneSvg": 82631,
	"./HomeHero/PhoneSvg.tsx": 82631,
	"./HomeHero/Video": 91852,
	"./HomeHero/Video.tsx": 91852,
	"./HomeHero/helpers": 57900,
	"./HomeHero/helpers.ts": 57900,
	"./HomeHero/index": 89700,
	"./HomeHero/index.tsx": 89700,
	"./IconCards": 4432,
	"./IconCards/": 4432,
	"./IconCards/index": 4432,
	"./IconCards/index.tsx": 4432,
	"./IconGrid": 74968,
	"./IconGrid/": 74968,
	"./IconGrid/index": 74968,
	"./IconGrid/index.tsx": 74968,
	"./Investors": 58905,
	"./Investors/": 58905,
	"./Investors/index": 58905,
	"./Investors/index.tsx": 58905,
	"./JobApplicationForm": 24463,
	"./JobApplicationForm/": 24463,
	"./JobApplicationForm/index": 24463,
	"./JobApplicationForm/index.tsx": 24463,
	"./JobsSection": 69220,
	"./JobsSection/": 69220,
	"./JobsSection/index": 69220,
	"./JobsSection/index.tsx": 69220,
	"./Login": 37180,
	"./Login/": 37180,
	"./Login/index": 37180,
	"./Login/index.tsx": 37180,
	"./Logo": 19105,
	"./Logo/": 19105,
	"./Logo/index": 19105,
	"./Logo/index.tsx": 19105,
	"./MDXComponents": 97742,
	"./MDXComponents/": 97742,
	"./MDXComponents/Card": 95086,
	"./MDXComponents/Card.tsx": 95086,
	"./MDXComponents/CodeBlock": 5910,
	"./MDXComponents/CodeBlock.tsx": 5910,
	"./MDXComponents/DocCodeBlock": 42231,
	"./MDXComponents/DocCodeBlock.tsx": 42231,
	"./MDXComponents/HeroContainer": 84323,
	"./MDXComponents/HeroContainer.tsx": 84323,
	"./MDXComponents/KeyboardTable": 77969,
	"./MDXComponents/KeyboardTable.tsx": 77969,
	"./MDXComponents/Post": 99421,
	"./MDXComponents/Post.tsx": 99421,
	"./MDXComponents/Pre": 5909,
	"./MDXComponents/Pre.tsx": 5909,
	"./MDXComponents/Preview": 19822,
	"./MDXComponents/Preview.tsx": 19822,
	"./MDXComponents/Table": 32003,
	"./MDXComponents/Table.tsx": 32003,
	"./MDXComponents/TableContainer": 73212,
	"./MDXComponents/TableContainer.tsx": 73212,
	"./MDXComponents/index": 97742,
	"./MDXComponents/index.tsx": 97742,
	"./MDXComponents/releaseHelpers": 72844,
	"./MDXComponents/releaseHelpers.tsx": 72844,
	"./NavDropdown": 90210,
	"./NavDropdown/": 90210,
	"./NavDropdown/index": 90210,
	"./NavDropdown/index.tsx": 90210,
	"./Navigation": 87091,
	"./Navigation/": 87091,
	"./Navigation/base": 86160,
	"./Navigation/base.tsx": 86160,
	"./Navigation/breadcrumb": 28524,
	"./Navigation/breadcrumb/": 28524,
	"./Navigation/breadcrumb/dropdown": 28637,
	"./Navigation/breadcrumb/dropdown.tsx": 28637,
	"./Navigation/breadcrumb/index": 28524,
	"./Navigation/breadcrumb/index.tsx": 28524,
	"./Navigation/docs": 16590,
	"./Navigation/docs.tsx": 16590,
	"./Navigation/index": 87091,
	"./Navigation/index.tsx": 87091,
	"./Navigation/mobile/authButtons": 49938,
	"./Navigation/mobile/authButtons.tsx": 49938,
	"./Navigation/mobile/docs-submenu": 59454,
	"./Navigation/mobile/docs-submenu.tsx": 59454,
	"./Navigation/mobile/menu": 89559,
	"./Navigation/mobile/menu.tsx": 89559,
	"./OffsetPortableText": 59313,
	"./OffsetPortableText/": 59313,
	"./OffsetPortableText/index": 59313,
	"./OffsetPortableText/index.tsx": 59313,
	"./Prefooter": 85873,
	"./Prefooter/": 85873,
	"./Prefooter/index": 85873,
	"./Prefooter/index.tsx": 85873,
	"./Pricing/pricingCalculator": 83951,
	"./Pricing/pricingCalculator.tsx": 83951,
	"./Pricing/pricingCalculatorComponents": 42755,
	"./Pricing/pricingCalculatorComponents.tsx": 42755,
	"./Pricing/pricingCard": 14402,
	"./Pricing/pricingCard.tsx": 14402,
	"./Pricing/pricingCardsContainer": 67044,
	"./Pricing/pricingCardsContainer.tsx": 67044,
	"./PricingCards": 75724,
	"./PricingCards/": 75724,
	"./PricingCards/index": 75724,
	"./PricingCards/index.tsx": 75724,
	"./PrinciplesSection": 22734,
	"./PrinciplesSection/": 22734,
	"./PrinciplesSection/index": 22734,
	"./PrinciplesSection/index.tsx": 22734,
	"./RegionSelector": 72074,
	"./RegionSelector/": 72074,
	"./RegionSelector/index": 72074,
	"./RegionSelector/index.tsx": 72074,
	"./Serializers": 69702,
	"./Serializers/": 69702,
	"./Serializers/index": 69702,
	"./Serializers/index.tsx": 69702,
	"./SimpleBlockContent": 35314,
	"./SimpleBlockContent/": 35314,
	"./SimpleBlockContent/index": 35314,
	"./SimpleBlockContent/index.tsx": 35314,
	"./SocialProof": 48284,
	"./SocialProof/": 48284,
	"./SocialProof/index": 48284,
	"./SocialProof/index.tsx": 48284,
	"./SplitImage": 54377,
	"./SplitImage/": 54377,
	"./SplitImage/index": 54377,
	"./SplitImage/index.tsx": 54377,
	"./TableOfContents": 97049,
	"./TableOfContents/": 97049,
	"./TableOfContents/bullet-svg": 48880,
	"./TableOfContents/bullet-svg.tsx": 48880,
	"./TableOfContents/index": 97049,
	"./TableOfContents/index.tsx": 97049,
	"./TeamMember": 49544,
	"./TeamMember/": 49544,
	"./TeamMember/index": 49544,
	"./TeamMember/index.tsx": 49544,
	"./TeamSection": 52885,
	"./TeamSection/": 52885,
	"./TeamSection/index": 52885,
	"./TeamSection/index.tsx": 52885,
	"./Testimonials": 43031,
	"./Testimonials/": 43031,
	"./Testimonials/Card": 1519,
	"./Testimonials/Card.tsx": 1519,
	"./Testimonials/index": 43031,
	"./Testimonials/index.tsx": 43031,
	"./TextSection": 26607,
	"./TextSection/": 26607,
	"./TextSection/index": 26607,
	"./TextSection/index.tsx": 26607,
	"./ToolkitSection": 26866,
	"./ToolkitSection/": 26866,
	"./ToolkitSection/index": 26866,
	"./ToolkitSection/index.tsx": 26866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17060;